(function ($) {
  const animateEvent = null;


  const transitionEvents = 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';


  const animateEvents = 'webkitAnimationEnd oanimationend msAnimationEnd animationend';


  let Utils;

  Utils = {
    whichEvent(settings) {
      if (settings.transition) settings.animation = false;
      return settings;
    },
  };

  function OnAnimate($el, settings, callback) {
    const defaults = {
      addClass: '',
      removeClass: '',
      transition: false,
      animation: true,
      onEnd() {},
      ms: 0,
    };

    settings = typeof settings === 'object' ? $.extend(defaults, settings) : defaults;

    this.settings = Utils.whichEvent(settings);
    this.callback = typeof callback === 'function' ? callback : function () {};
    this.$el = $el;

    this.init();
  }

  OnAnimate.prototype.init = function () {
    this.getEvents();
    this.listenForEnd();
  };

  OnAnimate.prototype.destroy = function () {
    this.$el.off(this.animateEvent);
  };

  OnAnimate.prototype.getEvents = function () {
    this.animateEvent = this.settings.transition ? transitionEvents : animateEvents;
    if (this.settings.transition && this.settings.animate) this.animateEvent = `${transitionEvents} ${animateEvents}`;
  };

  OnAnimate.prototype.listenForEnd = function () {
    const self = this;

    this.$el
      .addClass(self.settings.addClass)
      .removeClass(self.settings.removeClass)
      .one(self.animateEvent, () => {
        setTimeout(() => {
          self.callback.call(self.$el);
          self.destroy();
        }, self.settings.ms);
      });
  };

  $.fn.onAnimate = function (settings, callback) {
    return this.each(function () {
      const onAnimate = new OnAnimate($(this), settings, callback);
    });
  };
}(jQuery));
